let ServiceTimeUnit = /*#__PURE__*/function (ServiceTimeUnit) {
  ServiceTimeUnit["SECONDS"] = "SECONDS";
  ServiceTimeUnit["HOURS"] = "HOURS";
  ServiceTimeUnit["MINUTES"] = "MINUTES";
  ServiceTimeUnit["DAYS"] = "DAYS";
  ServiceTimeUnit["WEEKS"] = "WEEKS";
  return ServiceTimeUnit;
}({});

export { ServiceTimeUnit };
//# sourceMappingURL=ServiceTimeLeftForFirstAvailableDate.js.map
